import { THROW_ERROR, DISMISS_ERROR } from '../constants';

export const throwError = (errorObject) => async (dispatch) => {
  dispatch({ type: THROW_ERROR, payload: errorObject });
};

export const dismissError = () => async (dispatch) => {
  dispatch({ type: DISMISS_ERROR });
};
